import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=681e6922&scoped=true"
import script from "./ProductSelector.vue?vue&type=script&lang=js"
export * from "./ProductSelector.vue?vue&type=script&lang=js"
import style0 from "./ProductSelector.vue?vue&type=style&index=0&id=681e6922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681e6922",
  null
  
)

export default component.exports